import { ScatterChart } from '@mui/x-charts/ScatterChart';

export default function ScatterDataset() {
  return (
    <ScatterChart
      dataset={dataset}
      series={[
        { datasetKeys: { x: 'x1', y: 'y1' }, label: 'Series A' },
        { datasetKeys: { x: 'x2', y: 'y2' }, label: 'Series B' },
      ]}
      {...chartSetting}
    />
  );
}

const dataset = [
  { x1: 373, y1: 434, x2: 304, y2: 349 },
  { x1: 173, y1: 437, x2: 208, y2: 347 },
  { x1: 68, y1: 292, x2: 151, y2: 280 },
  { x1: 121, y1: 116, x2: 185, y2: 176 },
  { x1: 322, y1: 61, x2: 278, y2: 170 },
  { x1: 466, y1: 210, x2: 346, y2: 246 },
  { x1: 418, y1: 403, x2: 326, y2: 333 },
  { x1: 224, y1: 449, x2: 235, y2: 352 },
  { x1: 87, y1: 335, x2: 158, y2: 311 },
  { x1: 104, y1: 167, x2: 166, y2: 218 },
  { x1: 262, y1: 70, x2: 251, y2: 161 },
  { x1: 421, y1: 167, x2: 335, y2: 199 },
  { x1: 442, y1: 352, x2: 341, y2: 302 },
  { x1: 294, y1: 474, x2: 264, y2: 366 },
  { x1: 101, y1: 386, x2: 174, y2: 318 },
  { x1: 64, y1: 198, x2: 154, y2: 227 },
  { x1: 222, y1: 75, x2: 223, y2: 181 },
  { x1: 411, y1: 105, x2: 316, y2: 204 },
  { x1: 457, y1: 290, x2: 349, y2: 274 },
  { x1: 348, y1: 455, x2: 291, y2: 357 },
  { x1: 165, y1: 427, x2: 195, y2: 358 },
  { x1: 65, y1: 277, x2: 150, y2: 265 },
  { x1: 153, y1: 94, x2: 197, y2: 175 },
  { x1: 340, y1: 93, x2: 294, y2: 163 },
  { x1: 476, y1: 253, x2: 352, y2: 264 },
  { x1: 385, y1: 425, x2: 317, y2: 332 },
  { x1: 221, y1: 448, x2: 221, y2: 376 },
  { x1: 60, y1: 327, x2: 154, y2: 281 },
  { x1: 129, y1: 128, x2: 175, y2: 213 },
  { x1: 304, y1: 67, x2: 267, y2: 173 },
  { x1: 447, y1: 175, x2: 343, y2: 223 },
  { x1: 425, y1: 378, x2: 335, y2: 313 },
  { x1: 273, y1: 463, x2: 250, y2: 377 },
  { x1: 80, y1: 387, x2: 166, y2: 304 },
  { x1: 86, y1: 172, x2: 159, y2: 224 },
  { x1: 247, y1: 64, x2: 238, y2: 172 },
  { x1: 419, y1: 126, x2: 328, y2: 200 },
  { x1: 463, y1: 317, x2: 347, y2: 301 },
  { x1: 308, y1: 473, x2: 278, y2: 352 },
  { x1: 147, y1: 405, x2: 183, y2: 356 },
  { x1: 64, y1: 224, x2: 151, y2: 246 },
  { x1: 175, y1: 78, x2: 210, y2: 163 },
  { x1: 384, y1: 96, x2: 308, y2: 187 },
  { x1: 473, y1: 275, x2: 354, y2: 273 },
  { x1: 387, y1: 455, x2: 306, y2: 367 },
  { x1: 193, y1: 445, x2: 208, y2: 372 },
  { x1: 51, y1: 298, x2: 151, y2: 264 },
  { x1: 154, y1: 116, x2: 187, y2: 205 },
  { x1: 342, y1: 73, x2: 283, y2: 184 },
  { x1: 467, y1: 199, x2: 348, y2: 246 },
];

const chartSetting = {
  yAxis: [
    {
      label: 'rainfall (mm)',
      width: 60,
    },
  ],
  height: 300,
};
